import React from "react";
import PageHero from "../components/ui-custom/PageHero";
import GlassCard from "../components/ui-custom/GlassCard";
import Reveal from "../components/ui-custom/Reveal";
import { awards } from "../data/mock";
import { getIcon } from "../data/iconMap";

const Awards = () => {
  return (
    <div>
      <PageHero
        eyebrow="Corporate / Awards and Accolades"
        title="Awards & Certifications"
        subtitle="Recognitions that reflect our commitment to quality, safety, environmental stewardship and export excellence."
      />
      <section className="px-6 pb-24">
        <div className="max-w-6xl mx-auto grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {awards.map((a, i) => {
            const Icon = getIcon(a.icon);
            return (
              <Reveal key={a.title} delay={i * 0.06}>
                <GlassCard tilt accent="amber" className="p-7 h-full flex flex-col items-start gap-4">
                  <span className="w-14 h-14 rounded-xl flex items-center justify-center bg-qamber/10 border border-qamber/25">
                    <Icon size={26} className="text-qamber" />
                  </span>
                  <div>
                    <h3 className="font-display font-semibold text-foreground text-base mb-1">{a.title}</h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">{a.subtitle}</p>
                  </div>
                </GlassCard>
              </Reveal>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default Awards;
